import React, { useState } from 'react';
import './PortalDemo.css';

function PortalDemo() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    company: ''
  });
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/demo/request-access`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });

      const data = await response.json();

      if (response.ok) {
        setSubmitted(true);
      } else {
        setError(data.detail || 'Something went wrong. Please try again.');
      }
    } catch (err) {
      setError('Unable to connect. Please try again later.');
    }

    setLoading(false);
  };

  if (submitted) {
    return (
      <div className="portal-demo-page">
        <div className="demo-container success-container">
          <div className="success-icon">✓</div>
          <h1>Check Your Email</h1>
          <p className="success-message">
            We've sent a demo access link to <strong>{formData.email}</strong>
          </p>
          <p className="success-details">
            The link will be valid for 7 days. If you don't see the email, please check your spam folder.
          </p>
          <div className="success-note">
            <p>Questions? Contact us at <a href="mailto:hello@f-itscore.com">hello@f-itscore.com</a></p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="portal-demo-page">
      <div className="demo-container">
        <div className="demo-header">
          <h1>Explore the Management Portal</h1>
          <p>See how F-IT Score helps organisations monitor and improve workforce&nbsp;wellbeing</p>
        </div>

        <div className="demo-features">
          <div className="feature">
            <span className="feature-icon">✓</span>
            <span>Real-time wellbeing dashboard</span>
          </div>
          <div className="feature">
            <span className="feature-icon">✓</span>
            <span>Anonymous aggregated data</span>
          </div>
          <div className="feature">
            <span className="feature-icon">✓</span>
            <span>Trend analysis & reporting</span>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="demo-form">
          <div className="form-group">
            <label htmlFor="name">Your Name *</label>
            <input
              type="text"
              id="name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              required
              placeholder="John Smith"
            />
          </div>

          <div className="form-group">
            <label htmlFor="email">Work Email *</label>
            <input
              type="email"
              id="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              required
              placeholder="john@company.com"
            />
          </div>

          <div className="form-group">
            <label htmlFor="company">Company Name *</label>
            <input
              type="text"
              id="company"
              name="company"
              value={formData.company}
              onChange={handleChange}
              required
              placeholder="Acme Ltd"
            />
          </div>

          {error && <div className="error-message">{error}</div>}

          <button type="submit" className="submit-btn" disabled={loading}>
            {loading ? 'Sending...' : 'Send Demo Access Link'}
          </button>

          <p className="form-note">
            We'll send a secure link to access the demo portal. Your details will only be used to follow up on your&nbsp;interest.
          </p>
        </form>
      </div>
    </div>
  );
}

export default PortalDemo;
